// extracted by mini-css-extract-plugin
export var root = "sign-in-legal-module--root--359c4";